import { cloneDeep } from 'lodash'

export const moveItemInArray = (arr, oldIndex, newIndex) => {
    const _arr = cloneDeep(arr)
    const movingItem = _arr[oldIndex]
    _arr[oldIndex] = _arr[newIndex]
    _arr[newIndex] = movingItem
    return _arr
}

export const deleteItemInArray = (arr, index) => {
    const _arr = cloneDeep(arr)
    _arr.splice(index, 1)
    return _arr
}

export const cloneItemInArray = (arr, index, payload) => {
    const _arr = cloneDeep(arr)
    const parentItem = _arr[index]
    return addItemInArray(_arr, index + 1, { ...payload, data: parentItem })
}

export const addItemInArray = (
    arr,
    insertBeforeIndex,
    payload = {
        callback: () => {
            /**/
        },
        namePrefix: 'Item',
        data: {},
    },
) => {
    const _arr = cloneDeep(arr)

    let newItem
    if (typeof payload.callback === 'function') {
        newItem = payload.callback({ ...payload.data, name: `${payload.namePrefix} ${_arr.length}` })
    } else {
        newItem = { ...payload.data, name: `${payload.namePrefix} ${_arr.length}` }
    }
    const insertIndex = insertBeforeIndex && insertBeforeIndex < _arr.length ? insertBeforeIndex : _arr.length

    _arr.splice(insertIndex, 0, newItem)
    return _arr
}
